<template>
  <div class="discord">
    <div class="discord-info">
      <div class="social-media-right-part forMobile">
        <img
          v-motion
          src="img/discord-img-min.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>

      <div class="social-media-left-part">
        <h4>Discord</h4>
        <h1>Discord Integration</h1>
        <p>
          Create an exclusive community on Discord with our seamless
          integration.
        </p>

        <li class="first-list-item">
          <p>Create a vibrant community for your fans.</p>
        </li>
        <li class="first-list-item">
          <p>
            Create channels for specific topics like movie suggestions,
            horoscope, etc.
          </p>
        </li>
        <li class="first-list-item">
          <p>Do live voice recordings.</p>
        </li>
        <li class="first-list-item">
          <p>Play games with your subscribers.</p>
        </li>
      </div>

      <div class="social-media-right-part forWeb">
        <img
          v-motion
          src="img/discord-img-min.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.forMobile {
  display: none;
}

.discord {
  width: 100%;
  background-color: #f3f7f8;
}

.discord-info {
  width: 71rem;
  margin: auto;
  padding-top: 5rem;
  padding-bottom: 5rem;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  border-left: 2px solid white;
}

.social-media-left-part h4 {
  font-weight: 700;
  font-size: 1.5rem;
  padding-top: 1rem;
  padding-left: 25px;
  padding-right: 20px;
  color: #ff5f8f;
}

.social-media-left-part h1 {
  line-height: 1.2;
  font-size: 4rem;
  font-weight: 800;
  margin-left: -2px;
  padding-left: 1.45rem;
  border-left: 2px solid #ff5f8f;
}

.social-media-left-part > p {
  margin-left: 1.45rem;
  opacity: 0.5;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 3rem;
}

.social-media-left-part li {
  width: 100%;
  align-items: center;
  font-size: 1rem;
  top: -10rem;
  margin-bottom: 20px;
  margin-right: 30px;
  margin-left: 1.45rem;
  padding: 0px 20px 0px 40px;
  list-style: none;
  background-image: url('/img/discord-min.png');
  background-repeat: no-repeat;
  background-position: 0% 20%;
  background-size: 1rem;
}

.social-media-left-part li p {
  line-height: 1.5;
  font-weight: 500;
  opacity: 0.6;
}

.social-media-right-part {
  width: 70%;
  margin: auto;
}

.social-media-right-part img {
  width: 100%;
  margin: auto;
}

@media only screen and (max-width: 1400px) {
  .discord-info {
    width: 60rem;
  }
}

@media only screen and (max-width: 1050px) {
  .forMobile {
    display: block;
  }

  .forWeb {
    display: none;
  }

  .discord-info {
    width: 40rem;
    grid-template-columns: 1fr;
  }

  .social-media-right-part img {
    margin-top: 3rem;
  }
}

@media only screen and (max-width: 650px) {
  .discord-info {
    width: 90%;
    border-left: none;
  }

  .social-media-left-part h4 {
    font-size: 1rem;
    padding-left: 0;
    margin-left: 0;
  }

  .social-media-left-part h1 {
    font-size: 2rem;
    border-left: none;
    margin-left: 0;
    padding-left: 0;
  }

  .social-media-left-part p {
    margin-left: 0;
    padding-left: 0;
    font-size: 1rem;
  }

  .social-media-logos {
    margin-left: 0;
    padding-left: 0;
  }

  .social-media-right-part {
    width: 100%;
  }

  .social-media-right-part img {
    width: 90%;
  }

  .social-media-left-part li {
    margin-left: 0;
  }
}
</style>
